import { useState } from "react";
import { getMonthAndYearFromDate } from "../../../helpers";

const defaultWorkHistory = {
  title: "",
  companyName: "",
  fromMonth: "",
  fromYear: "",
  toMonth: "",
  toYear: "",
  description: "",
};

export const workHistoryConstraints = {
  title: {
    presence: { allowEmpty: false, message: "^Please enter job title" },
  },
  companyName: {
    presence: { allowEmpty: false, message: "^Please enter company" },
  },
  fromMonth: {
    presence: { allowEmpty: false, message: "^Please select start date" },
  },
  fromYear: {
    presence: { allowEmpty: false, message: "^Please select start date" },
  },
  toMonth: (value, attributes) => {
    if (!attributes.currentlyWorkHere) {
      return {
        presence: { allowEmpty: false, message: "^Please select end date" },
        isAfter: {
          toYear: "toYear",
          message: "^End date must be after start date",
        },
      };
    }
    return {};
  },
  toYear: (value, attributes) => {
    if (!attributes.currentlyWorkHere) {
      return {
        presence: { allowEmpty: false, message: "^Please select end date" },
        isAfter: {
          toMonth: "toMonth",
          message: "^End date must be after start date",
        },
      };
    }
    return {};
  },
};

export const useWorkHistoryState = (workHistories) => {
  const initialState = workHistories.reduce(
    (acc, workHistory, index) => {
      const from = getMonthAndYearFromDate(workHistory?.dateFrom);
      const to = getMonthAndYearFromDate(workHistory?.dateTo);
      return {
        ...acc,
        [index]: {
          toMonth: to.month,
          toYear: to.year,
          fromMonth: from.month,
          fromYear: from.year,
          ...workHistory,
        },
      };
    },
    {
      0: {
        ...defaultWorkHistory,
        currentlyWorkHere: false,
      },
    }
  );

  const [workHistoryState, setWorkHistoryState] = useState(initialState);

  const initialErrors = workHistories.reduce(
    (acc, workHistory, index) => {
      return {
        ...acc,
        [index]: { ...defaultWorkHistory },
      };
    },
    {
      0: { ...defaultWorkHistory },
    }
  );
  const [workHistoryErrors, setWorkHistoryErrors] = useState(initialErrors);

  const onChange = (index, key, value) => {
    const updatedWorkHistory = {
      ...workHistoryState[index],
      [key]: value,
    };

    setWorkHistoryErrors({
      ...workHistoryErrors,
      [index]: {
        ...workHistoryErrors[index],
        ...(["toMonth", "toYear", "fromMonth", "fromYear"].includes(key) && {
          toMonth: "",
          toYear: "",
          fromMonth: "",
          fromYear: "",
        }),
        [key]: "",
      },
    });

    setWorkHistoryState({
      ...workHistoryState,
      [index]: updatedWorkHistory,
    });
  };

  const addWorkHistory = () => {
    const nextIndex = Object.keys(workHistoryState).length;
    setWorkHistoryState({
      ...workHistoryState,
      [nextIndex]: { ...defaultWorkHistory, currentlyWorkHere: false },
    });
    setWorkHistoryErrors({
      ...workHistoryErrors,
      [nextIndex]: { ...defaultWorkHistory },
    });
  };

  const removeWorkHistory = (index) => {
    const updatedWorkHistory = { ...workHistoryState };
    delete updatedWorkHistory[index];
    setWorkHistoryState(updatedWorkHistory);
    const updatedWorkHistoryErrors = { ...workHistoryErrors };
    delete updatedWorkHistoryErrors[index];
    setWorkHistoryErrors(updatedWorkHistoryErrors);
  };

  return [
    workHistoryState,
    onChange,
    addWorkHistory,
    removeWorkHistory,
    workHistoryErrors,
    setWorkHistoryErrors,
  ];
};
